import React from 'react';
import styled from 'styled-components';

import { VideoWithThumbnail } from '~/_legacy/components/atoms/video/withThumbnail';

import { media } from '~/utils';

export default function ({ org }) {
  const { video, videoThumbnail } = org;

  return (
    <Wrapper>
      <ImageWrapper>
        <VideoWithThumbnail image={videoThumbnail} video={video} />
      </ImageWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 235px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: flex;

  ${media.mid`
    margin: 0 10px;
  `}
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 235px;
`;
